import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97285b24"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ber-container"
}
const _hoisted_2 = { class: "ber-group" }
const _hoisted_3 = { class: "field-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Energy Rating (kWh/m2/yr)", -1))
const _hoisted_5 = { class: "field-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Emissions (kgCO2/m2/yr)", -1))
const _hoisted_7 = { class: "ber-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header" }, "Dual Motif Minimum Values", -1))
const _hoisted_9 = { class: "field-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Energy Rating (kWh/m2/yr)", -1))
const _hoisted_11 = { class: "field-container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Emissions (kgCO2/m2/yr)", -1))

import { PropType, computed } from "vue";
import { Certificates } from "acquaint-api/models/Certificates";
import NumberBoxField from "../ui/inputs/number-box-field.vue";
import { FieldSize } from "@/enums/system/FieldSize";


export default /*#__PURE__*/_defineComponent({
  __name: 'ber-input',
  props: {
  /** The model value representing the certificates data.
   * This prop is required and must be an object of type `Certificates`.
   */
  modelValue: {
    type: Object as PropType<Certificates>,
    required: true,
  },
  /** The validation group name to associate with the component.
   * This prop is optional and defaults to an empty string if not provided.
   */
  validationGroup: {
    type: String,
    default: "",
  },
},
  emits: [
  /**
   * Emitted when the `modelValue` is updated, usually triggered by a change in the Certificates.
   * @event update:modelValue
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const certificate = computed({
  get: () => props.modelValue,
  set: (value: Certificates) => emit("update:modelValue", value),
});

return (_ctx: any,_cache: any) => {
  return (certificate.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(NumberBoxField, {
              modelValue: certificate.value.eerCurrent,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((certificate.value.eerCurrent) = $event)),
              label: "",
              width: _unref(FieldSize).Small,
              "min-value": -9999,
              "max-value": 9999,
              "validation-group": __props.validationGroup
            }, null, 8, ["modelValue", "width", "validation-group"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(NumberBoxField, {
              modelValue: certificate.value.eirCurrent,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((certificate.value.eirCurrent) = $event)),
              label: "",
              width: _unref(FieldSize).Small,
              "min-value": -9999,
              "max-value": 9999,
              "validation-group": __props.validationGroup
            }, null, 8, ["modelValue", "width", "validation-group"])
          ]),
          _createVNode(NumberBoxField, {
            modelValue: certificate.value.eerPotential,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((certificate.value.eerPotential) = $event)),
            label: "Indicator",
            width: _unref(FieldSize).Small,
            "max-value": 10,
            "validation-group": __props.validationGroup
          }, null, 8, ["modelValue", "width", "validation-group"])
        ]),
        _createElementVNode("section", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(NumberBoxField, {
              modelValue: certificate.value.eerCurrentMin,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((certificate.value.eerCurrentMin) = $event)),
              label: "",
              width: _unref(FieldSize).Small,
              "min-value": -9999,
              "max-value": 9999,
              "validation-group": __props.validationGroup
            }, null, 8, ["modelValue", "width", "validation-group"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(NumberBoxField, {
              modelValue: certificate.value.eirCurrentMin,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((certificate.value.eirCurrentMin) = $event)),
              label: "",
              width: _unref(FieldSize).Small,
              "min-value": -9999,
              "max-value": 9999,
              "validation-group": __props.validationGroup
            }, null, 8, ["modelValue", "width", "validation-group"])
          ]),
          _createVNode(NumberBoxField, {
            modelValue: certificate.value.eerPotentialMin,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((certificate.value.eerPotentialMin) = $event)),
            label: "Indicator",
            width: _unref(FieldSize).Small,
            "max-value": 10,
            "validation-group": __props.validationGroup
          }, null, 8, ["modelValue", "width", "validation-group"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})